// Wait for everything to be ready
function initMobileMenu() {
    // console.log('=== MOBILE MENU DEBUG ===');

    // Check if elements exist
    const hamburgerBtn = document.querySelector('.m-header__hamburger');
    const mobileMenu = document.querySelector('.m-header__mobile-menu');

    // console.log('Hamburger button:', hamburgerBtn);
    // console.log('Mobile menu:', mobileMenu);

    // List all buttons to see what's available
    // const allButtons = document.querySelectorAll('button');
    // console.log('All buttons found:', allButtons.length);
    // allButtons.forEach((btn, index) => {
    //     console.log(`Button ${index}:`, btn.className, btn);
    // });

    // List all elements with mobile-menu class
    const allMobileMenus = document.querySelectorAll('[class*="mobile-menu"]');
    console.log('All mobile menu elements:', allMobileMenus.length);
    allMobileMenus.forEach((menu, index) => {
        console.log(`Menu ${index}:`, menu.className, menu);
    });

    // Menu opened function
    function menuOpened() {
        if (mobileMenu) {
            mobileMenu.classList.add('is-open');
            console.log('📱 Menu opened');
        }
        if (hamburgerBtn) {
            hamburgerBtn.classList.add('is-active');
        }
        document.body.classList.add('mobile-menu-open');
    }

    // Menu closed function
    function menuClosed() {
        if (mobileMenu) {
            mobileMenu.classList.remove('is-open');
            console.log('📱 Menu closed');
        }
        if (hamburgerBtn) {
            hamburgerBtn.classList.remove('is-active');
        }
        document.body.classList.remove('mobile-menu-open');
    }

    // If we found the elements, set up the functionality
    if (hamburgerBtn && mobileMenu) {
        console.log('✅ Both elements found! Setting up event listeners...');

        // Remove any existing listeners to prevent duplicates
        hamburgerBtn.removeEventListener('click', hamburgerBtn.clickHandler);

        // Create the click handler - PROPER TOGGLE
        hamburgerBtn.clickHandler = function(e) {
            e.preventDefault();
            console.log('🍔 Hamburger clicked!');

            const isOpen = mobileMenu.classList.contains('is-open');
            console.log('Menu currently open:', isOpen);

            // PROPER TOGGLE: Only call one function based on current state
            if (isOpen) {
                menuClosed();
                console.log('🔄 Menu was open, now closed');
            } else {
                menuOpened();
                console.log('🔄 Menu was closed, now opened');
            }
        };

        // Add the event listener
        hamburgerBtn.addEventListener('click', hamburgerBtn.clickHandler);

        // Set up main toggle buttons
        const mainToggles = document.querySelectorAll('.mobile-navigation__main-toggle');
        console.log('Main toggles found:', mainToggles.length);

        mainToggles.forEach(function(toggle, index) {
            console.log(`Setting up main toggle ${index}`);

            // Remove existing listeners
            if (toggle.clickHandler) {
                toggle.removeEventListener('click', toggle.clickHandler);
            }

            toggle.clickHandler = function(e) {
                e.preventDefault();
                console.log(`Main toggle ${index} clicked`);

                const parentItem = toggle.closest('.mobile-navigation__item');
                if (parentItem) {
                    const isExpanded = parentItem.classList.contains('is-expanded');

                    // Close all others first
                    document.querySelectorAll('.mobile-navigation__item').forEach(item => {
                        if (item !== parentItem) {
                            item.classList.remove('is-expanded');
                        }
                    });

                    // Toggle current
                    if (isExpanded) {
                        parentItem.classList.remove('is-expanded');
                        console.log(`Submenu ${index} closed`);
                    } else {
                        parentItem.classList.add('is-expanded');
                        console.log(`Submenu ${index} opened`);
                    }
                }
            };

            toggle.addEventListener('click', toggle.clickHandler);
        });

        // Set up sub toggle buttons
        const subToggles = document.querySelectorAll('.mobile-navigation__sub-toggle');
        console.log('Sub toggles found:', subToggles.length);

        subToggles.forEach(function(toggle, index) {
            // Remove existing listeners
            if (toggle.clickHandler) {
                toggle.removeEventListener('click', toggle.clickHandler);
            }

            toggle.clickHandler = function(e) {
                e.preventDefault();
                console.log(`Sub toggle ${index} clicked`);

                const columns = toggle.closest('.mobile-navigation__submenu-header').nextElementSibling;
                if (columns && columns.classList.contains('mobile-navigation__columns')) {
                    const isExpanded = columns.classList.contains('is-expanded');

                    if (isExpanded) {
                        columns.classList.remove('is-expanded');
                        toggle.classList.remove('is-active');
                        console.log(`Columns ${index} closed`);
                    } else {
                        columns.classList.add('is-expanded');
                        toggle.classList.add('is-active');
                        console.log(`Columns ${index} opened`);
                    }
                }
            };

            toggle.addEventListener('click', toggle.clickHandler);
        });

    } else {
        console.log('❌ Elements not found!');
        if (!hamburgerBtn) console.log('Missing: hamburger button');
        if (!mobileMenu) console.log('Missing: mobile menu');

        // Try to find similar elements
        console.log('Searching for similar elements...');
        const similarHamburger = document.querySelector('[class*="hamburger"]');
        const similarMenu = document.querySelector('[class*="mobile-menu"]');
        console.log('Similar hamburger:', similarHamburger);
        console.log('Similar menu:', similarMenu);
    }
}

// Initialize everything after page is fully loaded
window.addEventListener('load', function() {
    console.log('Page fully loaded, initializing components...');

    // Create and load the HTMX navigation component
    const navContainer = document.getElementById('navigation-container');
    const htmxDiv = document.createElement('div');
    htmxDiv.setAttribute('hx-get', 'https://goldfish-app-tma6l.ondigitalocean.app/components/navigation');
    htmxDiv.setAttribute('hx-trigger', 'load');
    htmxDiv.setAttribute('hx-swap', 'outerHTML');

    navContainer.appendChild(htmxDiv);

    // Process the HTMX element
    if (typeof htmx !== 'undefined') {
        htmx.process(htmxDiv);
    }

    // Load the main app script
    const appScript = document.createElement('script');
    appScript.src = 'https://goldfish-app-tma6l.ondigitalocean.app/static/dist/js/app.js?v=123';
    appScript.defer = true;

    // Initialize mobile menu after app script loads
    appScript.onload = function() {
        console.log('App script loaded, initializing mobile menu...');
        // Small delay to ensure HTMX has finished rendering
        setTimeout(initMobileMenu, 100);
    };

    // Fallback if script fails to load
    appScript.onerror = function() {
        console.log('App script failed to load, initializing mobile menu anyway...');
        setTimeout(initMobileMenu, 100);
    };

    document.head.appendChild(appScript);

    // Listen for HTMX events to re-initialize when content changes
    document.body.addEventListener('htmx:afterSwap', function(evt) {
        console.log('HTMX content swapped, re-initializing mobile menu...');
        setTimeout(initMobileMenu, 50);
    });

    // Listen for HTMX settle events (when animations complete)
    document.body.addEventListener('htmx:afterSettle', function(evt) {
        console.log('HTMX content settled, ensuring mobile menu is ready...');
        setTimeout(initMobileMenu, 10);
    });
});

// Backup initialization methods
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        console.log('DOM Content Loaded, setting up backup initialization...');
        setTimeout(initMobileMenu, 500);
    });
} else {
    console.log('DOM already loaded, setting up immediate backup...');
    setTimeout(initMobileMenu, 100);
}

// Additional backup
setTimeout(function() {
    console.log('Final backup initialization...');
    initMobileMenu();
}, 1000);

// Make it globally available for debugging
window.initMobileMenu = initMobileMenu;

// Global function for testing (simplified)
window.triggerMenuToggle = function() {
    const mobileMenu = document.querySelector('.m-header__mobile-menu');
    const hamburgerBtn = document.querySelector('.m-header__hamburger');

    if (mobileMenu && hamburgerBtn) {
        const isOpen = mobileMenu.classList.contains('is-open');
        console.log('🔄 Manually toggling menu. Currently open:', isOpen);

        if (isOpen) {
            mobileMenu.classList.remove('is-open');
            hamburgerBtn.classList.remove('is-active');
            document.body.classList.remove('mobile-menu-open');
            console.log('📱 Manual menu closed');
        } else {
            mobileMenu.classList.add('is-open');
            hamburgerBtn.classList.add('is-active');
            document.body.classList.add('mobile-menu-open');
            console.log('📱 Manual menu opened');
        }
    } else {
        console.log('❌ Elements not found for manual toggle');
    }
};